import React, { useEffect, useState } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import TokenService from '../../utils/tokenService';
import { refreshTokens } from '../../utils/apiClient';

const ProtectedRoute = ({ requiredRoles = [] }) => {
  const location = useLocation();
  const [authState, setAuthState] = useState({
    status: 'checking',
    userRoles: []
  });

  useEffect(() => {
    const verifyToken = async () => {
      const decodedToken = TokenService.getIdTokenInfo();
      
      if (!decodedToken) {
        TokenService.clearTokens();
        setAuthState({ status: 'unauthenticated' });
        return;
      }

      try {
        const isExpired = TokenService.isTokenExpired(TokenService.getIdToken());
        
        if (!isExpired) {
          const roles = (decodedToken['custom:roles'] || '')
            .split(',')
            .map(r => r.trim());
          setAuthState({ status: 'authenticated', userRoles: roles });
          return;
        }
        
        try {
          await refreshTokens();
          const newDecoded = TokenService.getIdTokenInfo();
          if (!newDecoded) throw new Error('Could not decode refreshed id token');
          const roles = (newDecoded['custom:roles'] || '')
            .split(',')
            .map(r => r.trim());
          setAuthState({ status: 'authenticated', userRoles: roles });
        } catch (refreshError) {
          TokenService.clearTokens();
          setAuthState({ status: 'unauthenticated' });
        }
      } catch (error) {
        TokenService.clearTokens();
        setAuthState({ status: 'unauthenticated' });
      } 
    };

    verifyToken();
  }, [location]);

  if (authState.status === 'checking') {
    return <div>Loading...</div>;
  }

  if (authState.status === 'unauthenticated') {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (requiredRoles.length && 
      !requiredRoles.some(r => authState.userRoles.includes(r))) {
    return <Navigate to="/404" replace />;
  }

  return <Outlet />;
};

export default ProtectedRoute;